import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { ApiRequestBuilderSettings } from './api-request-builder-settings';

@Injectable({ providedIn: 'root' })
export class ApiRequestBuilderService extends BaseService {
  /**
   * Makes an API call with interpolated path params and query params.
   * @param endpoint e.g. 'gis/{id}/layer'
   * @param queryParams e.g. { type: 'main', active: true }
   * @param pathParams e.g. { id: 123 }
   * @param method HTTP method, defaults to 'get'
   */
  buildRequest<T>(settings: ApiRequestBuilderSettings) {
    const { endpoint, pathParams, queryParams, method, body, cacheOpts, absoluteUrl } = settings;

    // Interpolate path params
    const urlPath = this.interpolatePathParams(endpoint, pathParams);

    // Build query string
    const queryString = this.buildQueryString(queryParams);

    const url = absoluteUrl
      ? `${urlPath}${queryString}`
      : `${this.apiUrl}/${urlPath}${queryString}`;

    switch (method) {
      case 'post':
        return this.httpClient.post<T>(url, body);
      case 'put':
        return this.httpClient.put<T>(url, body);
      case 'delete':
        return this.httpClient.delete<T>(url);
      default:
        return this.httpCacheClient.get<T>(url, cacheOpts);
    }
  }

  private interpolatePathParams(endpoint: string, pathParams: { [key: string]: any }): string {
    let urlPath = endpoint;
    if (pathParams) {
      Object.keys(pathParams).forEach((key) => {
        urlPath = urlPath.replace(`{${key}}`, encodeURIComponent(pathParams[key]));
      });
    }
    return urlPath;
  }

  private buildQueryString(queryParams: { [key: string]: any }): string {
    let queryString = '';
    if (queryParams) {
      const params = Object.entries(queryParams)
        .filter(([_, v]) => v !== undefined && v !== null)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      if (params) {
        queryString = `?${params}`;
      }
    }
    return queryString;
  }
}
